import React, { Component } from 'react'
import Particles from 'react-particles-js';
import { palette } from '../../Styles/colors'
import { Container } from './styles'


class Background extends Component {
  render() {
    return(
      <Container>
        <Particles
          width="150%"
          height="100vh"
          params={{
            particles: {
              color: {
                value: palette.highlight
              },
              shape: {
                type: 'triangle',
                stroke: {
                  width: 2,
                  color: palette.highlight
                }
              }
            }
          }}/>
      </Container>
    )
  }
}

export default Background



// WEBPACK FOOTER //
// ./src/Components/Background/index.js